import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import selectOptionData, { fleetMasterFormEdit } from "../../../../constansts/LocalData";
import ServiceRecord from "./ServiceRecord";
import Tyre from "./Tyre";
import MonthlyMaintenanceBudget from "./MonthlyMaintenanceBudget";
import { useDispatch, useSelector } from "react-redux";
import {
   fetchSingleFleetAsync,
   getFleetMasterDropdownDataAsync,
} from "../../../../redux/features/fleetMaster";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import VehicleDetails from "./VehicleDetails";

export default function FleetMasterEdit() {
   const params = useParams();
   const dispatch = useDispatch();

   const fleetMaster = useSelector((state) => state.fleetMaster);
   const singleFleetMaster = fleetMaster?.singleFleetMaster;

   const [currentTabIndex, setCurrentTabIndex] = useState(0);

   const [tyreAdd, setTyreAdd] = useState([
      {
         id: 1,
         odometerReading: "",
         tyreType: "",
         tyreChangeDate: "",
         tyreAmount: "",
         tyreStationName: "",
         tyreCompanyName: "",
         tyreBillUpload: "",
      },
   ]);

   const [serviceBillAdd, setServiceBillAdd] = useState([
      {
         id: 1,
         odometerReading: "",
         serviceDate: "",
         serviceAmount: "",
         serviceStationName: "",
         serviceBillUpload: null,
      },
   ]);

   const [maintenanceBudget, setMaintenanceBudget] = useState([
      {
         id: 1,
         amount: "",
         toDate: "",
         fromDate: "",
      },
   ]);

   useEffect(() => {
      setTyreAdd(
         singleFleetMaster?.tyres?.map((item, index) => ({
            id: item?.id,
            odometerReading: item?.odometer_reading,
            tyreType: item?.tyre_type_id,
            tyreChangeDate: item?.tyre_change_date,
            tyreAmount: item?.tyre_amount,
            tyreStationName: item?.tyre_station_name,
            tyreCompanyName: item?.tyre_company_name,
            tyreBillUpload: item?.bill_upload_along_with_warranty_status,
         })),
      );

      setServiceBillAdd(
         singleFleetMaster?.service_records?.map((item, index) => ({
            id: item?.id,
            odometerReading: item?.odometer_reading,
            serviceDate: item?.service_date,
            serviceAmount: item?.service_amount,
            serviceStationName: item?.service_station_name,
            serviceBillUpload: item?.service_bill_upload,
         })),
      );

      setMaintenanceBudget(
         singleFleetMaster?.monthly_maintenance_budgets?.map((item, index) => ({
            id: item?.id,
            amount: item?.amount,
            toDate: item?.to_date,
            fromDate: item?.from_date,
         })),
      );
   }, [singleFleetMaster]);

   useEffect(() => {
      dispatch(getFleetMasterDropdownDataAsync());

      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchSingleFleetAsync({
            id: params?.id,
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error?.message ?? "Something went wrong");
            },
         }),
      );
   }, []);

   return (
      <div>
         <BodyHeader title="Edit Fleet Master" />
         <form className="">
            <div className="row">
               <div className="col-lg-12">
                  <div className="card card-primary card-outline card-tabs">
                     <div className="card-header p-0 pt-1 border-bottom-0">
                        <ul
                           className="nav nav-tabs"
                           id="custom-tabs-three-tab"
                           role="tablist"
                        >
                           {fleetMasterFormEdit.map((item) => (
                              <li className="nav-item">
                                 <a
                                    className={
                                       item.value === currentTabIndex
                                          ? "nav-link active"
                                          : "nav-link"
                                    }
                                    id={`${item.value}`}
                                    data-toggle="pill"
                                    href={`#${item.value}`}
                                    role="tab"
                                    aria-controls={`${item.value}`}
                                    aria-selected={
                                       item.value === currentTabIndex ? "true" : "false"
                                    }
                                    onClick={() => setCurrentTabIndex(item.value)}
                                 >
                                    {item.label}
                                 </a>
                              </li>
                           ))}
                        </ul>
                     </div>
                     <div className="card-body">
                        <div className="tab-content" id="custom-tabs-three-tabContent">
                           {currentTabIndex === 0 && (
                              <VehicleDetails singleFleetMaster={singleFleetMaster} />
                           )}
                           {currentTabIndex === 1 && (
                              <ServiceRecord serviceBillAdd={serviceBillAdd} />
                           )}
                           {currentTabIndex === 2 && (
                              <Tyre
                                 tyreAdd={tyreAdd}
                                 selectOptionData={selectOptionData}
                              />
                           )}
                           {currentTabIndex === 3 && (
                              <MonthlyMaintenanceBudget
                                 maintenanceBudget={maintenanceBudget}
                              />
                           )}
                        </div>
                        <div className="col-12 mt-3 text-right">
                           {currentTabIndex !== 0 && (
                              <button
                                 className="btn btn-secondary px-4 py-3"
                                 type="button"
                                 onClick={() => setCurrentTabIndex(currentTabIndex - 1)}
                              >
                                 <h6 className="mb-0 text-uppercase">Back</h6>
                              </button>
                           )}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </form>
      </div>
   );
}
